import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Contacts = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({ name: false, email: false });
  const [submissionError, setSubmissionError] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const nameError = formData.name.trim() === "";
    const emailError = formData.email.trim() === "";

    if (nameError || emailError) {
      setErrors({ name: nameError, email: emailError });
      return;
    }

    try {
      setErrors({ name: false, email: false });
      setSubmissionError("");

      console.log("Отправка данных на сервер:", formData);

      const response = await fetch("/api/notifier", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Ошибка сервера: ${response.statusText}`);
      }

      setSubmitted(true);
      setFormData({ name: "", email: "", phone: "" });
    } catch (error: any) {
      setSubmissionError(error.message || "Не удалось отправить данные.");
    }
  };

  return (
    <article className="flex w-0 flex-1 flex-col gap-6 py-10">
      <div className="prose">
        <h1>Контакты</h1>
        <h2>Будьте в числе первых!</h2>
        <p>
          Оставьте свои контактные данные, и мы сообщим Вам, когда наш
          интернет-магазин начнет работу. Вас ждут эксклюзивные предложения и
          ранний доступ.
        </p>
      </div>

      <div className="flex flex-col gap-4 p-6 border border-gray-200 rounded-md bg-gray-50">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Имя <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className={`mt-1 block w-full rounded-md border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring focus:ring-indigo-300 ${
              errors.name ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.name && (
            <p className="mt-1 text-sm text-red-500">
              Пожалуйста, введите Ваше имя.
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            E-mail <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className={`mt-1 block w-full rounded-md border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring focus:ring-indigo-300 ${
              errors.email ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-500">
              Пожалуйста, введите корректный email.
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Телефон (по желанию)
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring focus:ring-indigo-300"
          />
        </div>

        <button
          className="w-full rounded-md bg-gray-800 px-4 py-2 text-white shadow-md hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
          onClick={handleSubmit}
        >
          Узнать первым
        </button>
      </div>

      {submitted && (
        <div className="mt-4 rounded-md bg-green-50 p-4 text-green-700 shadow-md">
          Спасибо за Вашу заявку! Мы свяжемся с Вами, когда магазин начнет
          работу.
        </div>
      )}

      {submissionError && (
        <div className="mt-4 rounded-md bg-red-50 p-4 text-red-700 shadow-md">
          {submissionError}
        </div>
      )}

        <div className="mt-4 flex flex-row flex-wrap gap-4 border-t py-12">
            <NavLink className="flex flex-row items-center gap-2 text-muted-foreground transition-colors hover:text-foreground ms-auto" to="/">
              <p className="text-end font-medium text-foreground">
                О проекте
              </p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-right size-5 shrink-0 rtl:rotate-180">
                <path d="m9 18 6-6-6-6">
                </path>
              </svg>
            </NavLink>
          </div>
    </article>
  );
};

export default Contacts;
